import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, Output, ViewChild, EventEmitter, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { GridComponent, FilterSettingsModel, DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonHttpService } from 'src/app/common.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { clientonboardBO, columnWidth, GetListBase } from '../client-onboarding/client-onboarding.model';
import { clientOnboardingService } from '../client-onboarding/client-onboarding.service';
import { Application_Employer_Identification_NumberDocumentBO, ClientAgreementDocumentMergedBO, EmployerOrPayerAppointmentOfAgentDocumentBO, Individual_Sole_Proprietor_OfAttornyDocumentBO, ParticipantAgreementDocumentBO, Release_of_InformationDocumentBO } from '../client-onboarding/files/files.model';
import { EditDetailsClient, functionpermission, onBoardingListBO } from '../client-parent/client-parent.model';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { employeeFilter, getgrid, OfficeNotesBO } from './client-onboardinglist.model';
import { clientOnboardinglistService } from './client-onboardinglist.service';
import { ClientOnboardService } from './client-onboardinglistdata.service';
import { ClientEmployeeDynamicFormBO } from '../client-employee-dynamicform/client-employee-dynamicform.model';


@Component({
  selector: 'app-client-onboardinglist',
  templateUrl: './client-onboardinglist.component.html',
  styleUrls: ['./client-onboardinglist.component.scss']
})

export class ClientOnboardinglistComponent implements OnInit {
  @Input() parentToOnboard: onBoardingListBO = new onBoardingListBO();
  @Output() dataEmitTemplate = new EventEmitter<onBoardingListBO>();
  OnboardList: any;
  getOnBoardList: GetListBase = new GetListBase();
  private onDestroy$: Subject<void> = new Subject<void>();
  public dataOnBoardclient: Observable<DataStateChangeEventArgs>;
  public formatOptions: object;
  public templatename: any;
  iscompleted: boolean = false; 
  ClinetDropDown: any = [];
  staffingList:any=[];
  selflist:any=[];
  agencyid_boll = false
  OfficeNotesBO = new OfficeNotesBO();
  filterOptions: FilterSettingsModel;
  initialPage: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  height: string = "200px";
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild("pdfClientOnboardinglist") pdfClientOnboardinglist;
  public data: Observable<DataStateChangeEventArgs>;
  public portalclientid: any
  stateList: any = [];
  clientProfile: any
  clientContact: any
  clientDocuments: any
  clientRequest: any
  ClientEmpList: any = [];
  clientemp: any = [];
  locationLid: any;
  Employee: string;
  empumpi: any = [];
  isEmp: boolean = false;
  umpi: string;
  payorreqID: string;
  pantsign: string = ''
  pantsign1: string = ''
  Partisign: string = ''
  signature: string = ''
  signhere1: string = ''
  signhere2: string = ''
  OnboardClientDocumentBO = new ClientAgreementDocumentMergedBO()
  public state: DataStateChangeEventArgs;
  clientonboardBO: clientonboardBO = new clientonboardBO();
  fp: functionpermission = new functionpermission();
  ClientAggrementId:any;
  constructor(public datePipe: DatePipe,
    public ClientService: ClientHttpService,
    private router: Router, public clientlist: ClientOnboardService, private toastrService: ToastrService, private ngxService: NgxUiLoaderService, public global: GlobalComponent, public clientdrop: clientOnboardinglistService,
    public clientservice: clientOnboardingService, public commonhttp: CommonHttpService, public datepipe: DatePipe)
     {
      this.dataOnBoardclient = clientlist
  }

  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };

  ngOnInit(): void {
    this.filterOptions = { type: 'Menu' };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      this.GetTemplateNameList();
    }
    this.getDocumentStatuusList();
    this.getcompletedStatuusList();
    this.GetDocumentList();
console.log(this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_PhoneNumber,"ppppppppppppppppppppp")
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };


    if (this.global.globalAgencyId || this.global.agencyCode) {
      this.agencyid_boll = true;
    }
    else {
      this.agencyid_boll = false;
    }

    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
   
   this.getself();
   this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Client");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.ClientService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
 

  ///////////////////////////////// Get Document List /////////////////////////////
  GetDocumentList() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      this.getOnBoardList.clientid = this.parentToOnboard.clientid;
      this.clientlist.exceuteAgency(this.getOnBoardList);
      this.dataOnBoardclient.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.OnboardList = data.result;

        this.ClinetDropDown = [];
        this.OnboardList.forEach(element => {
          this.ClinetDropDown.push(element.name)
          this.iscompleted = element.isCompleted;
          this.clientonboardBO.statusinfo = element.status;
  
        });
      })
    }
    else {

      this.clientlist.exceuteportal(this.getOnBoardList);
      this.dataOnBoardclient.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.OnboardList = data.result;

        this.ClinetDropDown = [];
        this.OnboardList.forEach(element => {
          this.ClinetDropDown.push(element.name)
        });

      })
    }
  }


    ///////////////////////// EDIT DOCUMENT ///////////////////////////////
  editpage(data) { 
    this.clientonboardBO.datalist = data;
    this.clientonboardBO.documentid = data.id;
    this.clientonboardBO.statusinfo = data.status
    this.global.requestId = data.id;
    this.clientonboardBO.isCompleted = data.isCompleted;
    this.clientonboardBO.clientID = this.parentToOnboard.clientid
    this.portalclientid = this.parentToOnboard.clientid;
    this.clientonboardBO.edit = true;
    this.clientonboardBO.view = true;
    this.clientonboardBO.add = false;
    this.global.docbool = true
  }


///////////////////////// ADD DOCUMENT ///////////////////////////////

  AddDocument() {
    this.clientonboardBO.edit = true;
    this.clientonboardBO.add = true;
    this.clientonboardBO.datalist = ''
    this.clientonboardBO.statusinfo = '';
    this.clientonboardBO.clientID = this.parentToOnboard.clientid
    this.portalclientid = this.parentToOnboard.clientid
    this.clientonboardBO.onboardingStatusLovCode = ''
    this.clientonboardBO.documentid = "00000000-0000-0000-0000-000000000000"
    this.global.docbool = true;
    this.clientonboardBO.isCompleted=false;
    this.GetTemplateNameList();
  }

 //////////////////////////// LOV DROPDOWN ///////////////////////////////////

  completedlist: any
  getcompletedStatuusList() {
    let params = new URLSearchParams();
    params.append("ListCode", "COMPLETED");
    this.clientdrop.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.completedlist = data;
      this.completedlist.push({ id: '00000000-0000-0000-0000-000000000000', lovName: "All" });
      this.getOnBoardList.completed = this.completedlist?.filter(s => s.lovName == "All")[0].id;

      
    })
  }

  statuslist: any
  getDocumentStatuusList() {
    let params = new URLSearchParams();
    params.append("ListCode", "DOCUMENTSTATUS");
    this.clientdrop.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.statuslist = data;
      this.statuslist.push({ id: '00000000-0000-0000-0000-000000000000', lovName: "All" });
      this.getOnBoardList.documentStatus = this.statuslist?.filter(s => s.lovName == "All")[0].id;

    })
  }


  documentlist: any
  GetTemplateNameList() {
    this.clientdrop.GetTemplateNameList().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.documentlist = data;
      this.documentlist.forEach((ele) => {
        if (this.templatename == null || this.templatename == undefined || this.templatename == '') {
          this.clientonboardBO.templateid = "00000000-0000-0000-0000-000000000000";
         
        }
        else {
          this.clientonboardBO.templateid = ele.id
        }

      })
    })
  }


//////////////////////////////// FILTER FUNCTION //////////////////////////
  ftype: string = "";
  datachangeonBoardEmp(state) {
    this.ftype = (state.action.requestType).toString();
    if (this.ftype != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getOnBoardList.orderColumn = state.sorted[0].name;
        this.getOnBoardList.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.ftype == "filtering" && state.action.action != "clearFilter") {
      this.getOnBoardList.field = state.action.currentFilterObject.field;
      this.getOnBoardList.matchCase = state.action.currentFilterObject.matchCase;
      this.getOnBoardList.operator = state.action.currentFilterObject.operator;
      this.getOnBoardList.value = state.action.currentFilterObject.value;
      if(this.getOnBoardList.type == 'number'){
        this.getOnBoardList.value = (this.getOnBoardList.value != null && this.getOnBoardList.value != undefined)
        ? this.getOnBoardList.value.toString() : null;
      }
    }
    if((this.ftype == "filtering" && state.action.action == "clearFilter") 
      || (this.getOnBoardList.type != 'string' && (this.getOnBoardList.value == null  || this.getOnBoardList.value == undefined || this.getOnBoardList.value == ''))) {
      this.getOnBoardList.field = "status";
      this.getOnBoardList.matchCase = false;
      this.getOnBoardList.operator = "startswith";
      this.getOnBoardList.value = "";
      this.getOnBoardList.type = "string"
    }
    this.getOnBoardList.agencyId = this.global.globalAgencyId;
    if (this.ftype == "paging" && state.action.name == "actionBegin") {
    }
    this.GetDocumentList();
  }


   OnBoardActionComplete(args) {
    this.getOnBoardList.currentpageno = this.grid.pageSettings.currentPage;
    this.getOnBoardList.pageitem = this.grid.pageSettings.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getOnBoardList.type = args.columnType
    }
  }

  ColumnArray: columnWidth[];
  onResize(args) {
    const column = this.grid.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.ColumnArray.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }

    });
   
  }


 ///////////////////////// CLIENT DOCUMENT PDFDOWNLOAD //////////////////////////

  ClientOnboardingDownload() {
    this.toastrService.success("PDF is Downloading!"),3000;
    this.ngxService.start();
    (this.pdfClientOnboardinglist.A4 = true),
      (this.pdfClientOnboardinglist.portrait = true),
      (this.pdfClientOnboardinglist.keepTogether = ".prevent-split"),
      (this.pdfClientOnboardinglist.scale = 0.8),
      (this.pdfClientOnboardinglist.height = 100),
      (this.pdfClientOnboardinglist.margin = {
        left: "0.2cm",
        top: "1cm",
        right: "0.2cm",
        bottom: "1cm",
      });
      this.pdfClientOnboardinglist.padding = { bottom: "50px" };
      this.pdfClientOnboardinglist.forcePageBreak = ".page-header";
      this.pdfClientOnboardinglist.saveAs('ClientOnboardReport.pdf')
      this.ngxService.stop();
  }


///////////////////// GET DOCUMENTDETAILS FOR PDF ////////////////////////

  GetonboardDetails(data) {
    this.ngxService.start();
    let params = new URLSearchParams();

    params.append("Clientid", data.clientid);
    params.append("documentLid", data.id);
    this.clientservice.getpdf(params).subscribe((data: any) => {
      this.clientProfile = data.clientProfile
      this.clientContact = data.clientcontacts
      this.OnboardClientDocumentBO = new ClientAgreementDocumentMergedBO()
      this.OnboardClientDocumentBO.release_of_InformationDocumentBO = new Release_of_InformationDocumentBO();
      this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO = new EmployerOrPayerAppointmentOfAgentDocumentBO();
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO = new Application_Employer_Identification_NumberDocumentBO();
      this.OnboardClientDocumentBO.participantAgreementDocumentBO = new ParticipantAgreementDocumentBO();
      this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO = new Individual_Sole_Proprietor_OfAttornyDocumentBO();
      this.OnboardClientDocumentBO = data.clientdocuments
      this.OnboardClientDocumentBO.release_of_InformationDocumentBO.authorizeBestCare =  this.OnboardClientDocumentBO.release_of_InformationDocumentBO.authorizeBestCare?.toString() 
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc =  this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc?.toString()
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates =this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates?.toString();
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein = this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein?.toString()

console.log(this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO,"phphphphphphphpnnnnnnnnnn");


      if (this.OnboardClientDocumentBO != null) {
        if (this.OnboardClientDocumentBO.release_of_InformationDocumentBO != null) {
          this.OnboardClientDocumentBO.release_of_InformationDocumentBO.signDate = (this.OnboardClientDocumentBO.release_of_InformationDocumentBO.signDate != '' && this.OnboardClientDocumentBO.release_of_InformationDocumentBO.signDate != null && this.OnboardClientDocumentBO.release_of_InformationDocumentBO.signDate != undefined) ? this.datepipe.transform(this.OnboardClientDocumentBO.release_of_InformationDocumentBO.signDate, "MM/dd/yyyy") : null;

        }
        if (this.OnboardClientDocumentBO.participantAgreementDocumentBO != null) {
          this.OnboardClientDocumentBO.participantAgreementDocumentBO.effectivedate = (this.OnboardClientDocumentBO.participantAgreementDocumentBO.effectivedate != '' && this.OnboardClientDocumentBO.participantAgreementDocumentBO.effectivedate != undefined && this.OnboardClientDocumentBO.participantAgreementDocumentBO.effectivedate != null) ? this.datepipe.transform(this.OnboardClientDocumentBO.participantAgreementDocumentBO.effectivedate, "MM/dd/yyyy") : null;
          this.OnboardClientDocumentBO.participantAgreementDocumentBO.participantSign2Date = (this.OnboardClientDocumentBO.participantAgreementDocumentBO.participantSign2Date != '' && this.OnboardClientDocumentBO.participantAgreementDocumentBO.participantSign2Date != undefined && this.OnboardClientDocumentBO.participantAgreementDocumentBO.participantSign2Date != null) ? this.datepipe.transform(this.OnboardClientDocumentBO.participantAgreementDocumentBO.participantSign2Date, "MM/dd/yyyy") : null;

        }
        if (this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO != null) {
          this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date = (this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != '' && this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != undefined && this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != null) ? this.datepipe.transform(this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date, "MM/dd/yyyy") : null;
          this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate = (this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != '' && this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != undefined && this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != null) ? this.datepipe.transform(this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate, "MM/dd/yyyy") : null;
        }
        if (this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO != null) {
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != undefined && this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != null) ? this.datepipe.transform(this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted, "MM/dd/yyyy") : null;
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != undefined && this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != null) ? this.datepipe.transform(this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted, "MM/dd/yyyy") : null;
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != undefined && this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != null) ? this.datepipe.transform(this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid, "MM/dd/yyyy") : null;
        }
        if (this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO != null) {
          this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate = (this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != '' && this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != undefined && this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != null) ? this.datepipe.transform(this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate, "MM/dd/yyyy") : null;
          this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate = (this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != '' && this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != undefined && this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != null) ? this.datepipe.transform(this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate, "MM/dd/yyyy") : null;

        }
        this.signhere2 = this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO?.agentSign;
        this.signhere1 = this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO?.sign;
        this.pantsign1 = this.OnboardClientDocumentBO.release_of_InformationDocumentBO?.sign;
        this.pantsign = this.OnboardClientDocumentBO.participantAgreementDocumentBO?.participantSign1;
        this.Partisign = this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO?.signature;
        this.signature = this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO?.signature;
        this.getClientDetails();
      }
      setTimeout(() => {
        this.ClientOnboardingDownload();
      }, 2000);
    },
      (err: HttpErrorResponse) => {
        this.toastrService.error(err.error, "error");
      }
    );
    this.ngxService.stop();
  }
  
/////////////////////////// NOTES ////////////////
  disabledNotes:any;
  getOfficeNotes(data) {
    this.OfficeNotesBO.documentLid = data.id;
    this.OfficeNotesBO.officenotes = data.officeNotes;
  }
  OfficeNotes() {
    this.disabledNotes = true;
    this.clientdrop.SaveOfficeNote(this.OfficeNotesBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Office Notes saved Successfully!")
      this.GetDocumentList();
      this.disabledNotes = false;
      document.getElementById('openOfficeNotes')?.click();
    },
      (err: HttpErrorResponse) => {
        this.disabledNotes = false;
        this.toastrService.error(
          err.error.Request,
          "error",
        );
      })
  }


  clearFields() {
    this.OfficeNotesBO.officenotes = "";
  }

  Refresh() {
    this.getOnBoardList = new GetListBase()
    this.getOnBoardList.documentStatus = this.statuslist?.filter(s => s.lovName == "All")[0].id;
    this.getOnBoardList.completed = this.completedlist?.filter(s => s.lovName == "All")[0].id;
    this.GetDocumentList();
  }


  ///////////////////////// GO TO DOCUMENTPAGE //////////////////////////
  GoTODocument() {
    this.global.docbool = true;
    document.getElementById("templateNameModal")?.click();
    this.AddDocument();

  }


  dataEmitFromOnboard(value) {
    this.clientonboardBO.edit = false;
    this.clientonboardBO.add = false;
    this.GetDocumentList();
  }


   ///////////////// GETCLIENT DETAILS///////////////////
   getClientDetails() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("Clientid", this.parentToOnboard.clientid);
      this.clientservice.GetClientDetailsAgency(params).subscribe((data: any) => {
        console.log(data, "dataaaa")
        this.OnboardClientDocumentBO.participantAgreementDocumentBO.clientName = data.fullName != null ? data.fullName : null;
        this.OnboardClientDocumentBO.release_of_InformationDocumentBO.participantName = data.fullName != null ? data.fullName : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.agencyName = this.global.agencyName;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.employersOrPayerName = data.fullName != null ? data.fullName : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.suiteOrRoomNumber = data.street != null ? data.street : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.city = data.city != null ? data.city : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.state = data.state != null ? data.state : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.zip = data.zipCode != null ? data.zipCode : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.street_Addres_or_PoBox = data.street != null ? data.street : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.apt_or_Suit = data.street != null ? data.street : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.phoneNumber = data.phone1 != null ? data.phone1 : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.city = data.city != null ? data.city : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.state = data.state != null ? data.state : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.zipCode = data.zipCode != null ? data.zipCode : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.emailAddress = data.email != null ? data.email : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.taxpayerName = data.fullName != null ? data.fullName : null;
      //  this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_PhoneNumber = data.phone1 != null ? data.phone1 : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.agencyName = data.agencyName;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agenctsName = data.agencyName;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSuiteOrRoomNumber = data.agencyStreet != null ? data.agencyStreet : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity = data.agencyCity != null ? data.agencyCity : '';
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState = data.agencyState != null ? data.agencyState : '';
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip = data.agencyZipCode != null ? data.agencyZipCode : '';
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.agencyMailingAddress = data.agencyStreet != null ? data.agencyStreet : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.agencyCity_state_zip = (this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity != null || this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState != null || this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip != null) ? this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity + ',' + this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState + ',' + this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip : '' + ',' + '' + ',' + ''

      })


    }
    else {
      this.clientservice.GetClientDetailsportal().subscribe((data: any) => {
        console.log(data, "dataaaa")
        this.OnboardClientDocumentBO.participantAgreementDocumentBO.clientName = data.fullName != null ? data.fullName : null;
        this.OnboardClientDocumentBO.release_of_InformationDocumentBO.participantName = data.fullName != null ? data.fullName : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.employersOrPayerName = data.fullName != null ? data.fullName : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.suiteOrRoomNumber = data.street != null ? data.street : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.city = data.city != null ? data.city : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.state = data.state != null ? data.state : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.zip = data.zipCode != null ? data.zipCode : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.street_Addres_or_PoBox = data.street != null ? data.street : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.apt_or_Suit = data.street != null ? data.street : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.phoneNumber = data.phone1 != null ? data.phone1 : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.city = data.city != null ? data.city : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.state = data.state != null ? data.state : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.zipCode = data.zipCode != null ? data.zipCode : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.emailAddress = data.email != null ? data.email : null;
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.taxpayerName = data.fullName != null ? data.fullName : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.agencyName = data.agencyName;
      //  this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_PhoneNumber = data.phone1 != null ? data.phone1 : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agenctsName = data.agencyName;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSuiteOrRoomNumber = data.agencyStreet != null ? data.agencyStreet : null;
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity = data.agencyCity != null ? data.agencyCity : '';
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState = data.agencyState != null ? data.agencyState : '';
        this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip = data.agencyZipCode != null ? data.agencyZipCode : '';
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.agencyMailingAddress = data.agencyStreet != null ? data.agencyStreet : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.agencyCity_state_zip = (this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity != null || this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState != null || this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip != null) ? this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity + ',' + this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState + ',' + this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip : '' + ',' + '' + ',' + ''


      })
    }
  }




  getself() {
      let params = new URLSearchParams();
      params.append("listCode", "ApplicantTitle");
      this.clientservice.gettype(params).subscribe((data: any) => {
        this.selflist = data;
      })
  }

  DeleteClientAggrement(data) {
      this.ClientAggrementId=data.id;
  }

  Delete() {
    let param = new URLSearchParams()
    param.append("AggrementId", this.ClientAggrementId)
    this.clientdrop.DeleteClientAggrementInfo(param).subscribe((data: any) => {
      this.toastrService.success("Employee Aggrement Deleted successfully!");
      document.getElementById("openClientAggrdelete").click();
     this.GetDocumentList();
    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }

  //........................................TAPCHANGE.......................................
  OnboardingSelectedTab = 'TemplateDocument'
  ClientEmployeeDynamicForm:ClientEmployeeDynamicFormBO = new ClientEmployeeDynamicFormBO();
  isdynamicFormcontact:boolean=false;
  tabchange(val) {
    this.OnboardingSelectedTab = val;

    if (this.OnboardingSelectedTab == 'TemplateDocument') {
      this.GetDocumentList();
      this.isdynamicFormcontact=false;

    }
    else {
      this.isdynamicFormcontact=true;
      this.ClientEmployeeDynamicForm.dynamicClientType = "Employer";

     // this.getOnboardTemplateList()
    }
  }

  ngOnDestroy() {
    this.global.docbool = false;
  }

}

